import LdsIcon from '../LdsIcon/index.jsx';

export default function HamburgerMenu({
  toggleMobileMenu,
  openMenuButtonRef,
  isMobileMenuOpen,
}) {
  return (
    <div className="lds-header-mobile-actions">
      <button
        ref={openMenuButtonRef}
        data-testid="lds-open-menu-button"
        id="lds-open-menu-button"
        type="button"
        className="lds-button-base lds-header-toggle toggleMobileMenu"
        onClick={toggleMobileMenu}
      >
        <span className="lds-header-toggle-text"> Menu </span>
        <LdsIcon
          decorative
          className="lds-hamburger-menu-icon"
          name="List"
          inline
        />
      </button>
      <div aria-live="polite" className="screen-reader-text">
        Menu {isMobileMenuOpen ? 'opened' : 'closed'}
      </div>
    </div>
  );
}
